import { inject, provideAppInitializer } from "@angular/core";
import { lastValueFrom } from "rxjs";

import { AccessibilityService } from "@azm/core/services/accessibility";
import { ConfigService } from "@azm/core/services/config";
import { ThemeService } from "@azm/core/services/theme";
import { TranslateService } from "@azm/core/services/translate";
import { IconSpriteService } from "@azm/shared/components/display/icon/icon-sprite.service";

export function provideAppBootstrapInitializer() {
	return provideAppInitializer(() => {
		inject(ThemeService).initializeTheme();
		inject(AccessibilityService).initialize();
		inject(TranslateService).initializeLanguage();
		inject(IconSpriteService).prefetch();

		const configService = inject(ConfigService);

		return (async () => {
			await lastValueFrom(configService.initializeConfig());
		})();
	});
}
